






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'

@Component

export default class ViewFormasDePagamento extends Vue {
  currentCard: Object = {}

  mounted() {
    this.getPaymentMethods()
  }

  async getPaymentMethods() {
    const request = await ApiPlans.FormasDePagamento.getFormasDePagamento()
    this.currentCard = request.data.value
  }

  goToEditPaymentMethodPage() {
    this.$router.push('/pagamento/alterar')
  }
}
